import fast_deep_equal from 'fast-deep-equal';
import { set } from 'json-pointer';
import json_schema_ref_parser from 'json-schema-ref-parser';
import { Observable, pipe, UnaryFunction } from 'rxjs';
import { distinctUntilChanged, map } from 'rxjs/operators';
import { getFormValue } from '../../../../redux';
import { MobileLayoutNodeDefinition, NIFormData, parseFieldIdentifier, resolvePointer } from '../services';


export * from './hooks';

// types
export function updateFormValue(e: string, r: any, o: any) {
  const t = JSON.parse(JSON.stringify(r));
  set(t, parseFieldIdentifier(e), o);
  return t
}

export function resolveRefs(e: any): Promise<any> {
  const r = JSON.parse(JSON.stringify(e));
  return json_schema_ref_parser.dereference(window.location.origin, r, {})
}

export interface FormControlProps<T extends MobileLayoutNodeDefinition<any>> {
  path: string;
  definition: T;
}

export function rescopeDataPath(dataPath: string, scope: string) {
  return '{' + resolvePointer(parseFieldIdentifier(dataPath), scope) + '}';
}

export function spyFormValueChanges(dataPath: string, scope: string): UnaryFunction<Observable<NIFormData>, Observable<any>> {
  var n = rescopeDataPath(dataPath, scope);

  return pipe(
    map(e => getFormValue(n, e)),
    distinctUntilChanged((e, r) => fast_deep_equal(e, r))
  )
}

// todo types
// : UnaryFunction<Observable<FormData>, Observable<[{
//   [key: string]: any;
// }, FormData]>>
export function spyOn(paths: string[]) {
  return pipe(
    map((r: NIFormData) => {
      var n = paths.map(e => {
        var n;

        return n = {}, (n as { [key: string]: any })[e] = getFormValue(e, r), n;
      })
      .reduce((e, r) => {
        return Object.assign(Object.assign({}, e), r);
      });

      return [n, r];

    }),
    distinctUntilChanged((e, r) => fast_deep_equal(e[0], r[0]))
  )
}

export function isNullOrUndefined(e: any) {
    return e === undefined || e === null;
}

export function containsNullOrUndefined(terms: any[]) {
  return terms.some(s => s === null || s === undefined);
}

export const isLeapYear = (year: number) => {
  return year % 4 === 0 && (year % 100 !==0 || year % 400 === 0);
}
